import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Flex, ListItem, Table } from '@knockrentals/knock-shared-web-v2';
import { TabSectionHeader } from '../../../TabSections';
import { usePreferredProperties } from './use-preferred-properties';
import { columnRenderers, columns } from './column-config';
import { makeCss } from '../../../../../../../../knock-design-system';

export const DESCRIPTION =
  'Choose which properties to refer within the radius selected.';
export const TITLE = 'Preferred Properties';

const useCss = makeCss({
  tableWrapper: {
    '& .MuiTableContainer-root': {
      maxHeight: '400px',
    },
  },
});

const PreferredProperties = ({
  excludedPropertiesMap,
  propertyDataRows,
  setExcludedPropertiesMap,
  updateCrossSell,
}) => {
  const css = useCss();

  const { selectedProperties, updateSelectedProperties } =
    usePreferredProperties({
      excludedPropertiesMap,
      propertyDataRows,
      setExcludedPropertiesMap,
      updateCrossSell,
    });

  const selectedCountText = `${selectedProperties.length} of ${propertyDataRows.length} selected`;

  return (
    <Flex flexDirection="column">
      <ListItem
        component="div"
        disableGutters
        endSlot={<Chip label={selectedCountText} />}
        startSlot={<TabSectionHeader description={DESCRIPTION} title={TITLE} />}
      />
      <div css={css.tableWrapper}>
        <Table
          bordered
          columns={columns}
          columnRenderers={columnRenderers}
          onSelect={updateSelectedProperties}
          rows={propertyDataRows}
          rowId="propertyId"
          selectedRows={selectedProperties}
          stickyHeader
        />
      </div>
    </Flex>
  );
};

PreferredProperties.propTypes = {
  excludedPropertiesMap: PropTypes.objectOf(PropTypes.bool),
  propertyDataRows: PropTypes.arrayOf(
    PropTypes.shape({
      propertyId: PropTypes.number,
      propertyName: PropTypes.string,
      distance: PropTypes.number,
      unit: PropTypes.string,
    }),
  ),
  setExcludedPropertiesMap: PropTypes.func,
  updateCrossSell: PropTypes.func,
};

export default PreferredProperties;
